import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M4.767 14.77c-.787.589-1.599-.03-1.308-.997L4.65 9.802 1.44 7.324c-.777-.6-.474-1.61.496-1.61h4.006l1.252-3.993c.302-.965 1.309-.958 1.61 0l1.251 3.994h4.006c.976 0 1.272 1.01.496 1.609l-3.21 2.478 1.192 3.97c.29.968-.52 1.587-1.308.998l-3.233-2.417-3.232 2.417z',
    ],
};
const IconStarFilled = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconStarFilled.displayName = 'IconStarFilled';

export { IconStarFilled };
//# sourceMappingURL=IconStarFilled.js.map
